import * as yup from "yup";
export const passwordValidteObject = yup.string().trim().min(8, "Password must be atleast 8 characters").required('Password is required');
export const confirmPasswordValidateObject = yup.string().trim().required("Confirm password is required").test("is-valid-pass", "Passwords do not match", function (value) {
    const { password } = this.parent;
    if (!value) return false;
    return value === password;
});
export const emailValidateObject = yup
    .string("Enter your email").trim()
    .email("Enter a valid email")
    .required("Email is required")
export const ResetPasswordValidationSchema = yup.object({
    email: emailValidateObject,
    secretPin: yup
        .string("Enter secret pin").trim()
        .required("Temporary password is required"),
    password: passwordValidteObject,
    confirmPassword: confirmPasswordValidateObject,
});

export const ForgotPasswordFormValidationSchema = yup.object({
    email:emailValidateObject
})

export const ChangePasswordValidationSchema =  yup.object({
    currentPassword:yup.string().trim().required("Current Password is required"),
    password:passwordValidteObject,
    confirmPassword:confirmPasswordValidateObject
})